const messages = {
  title: "Moj profil",
  desc: "Dobrodošli u vaš osobni prostor. Ovdje možete ažurirati ili prilagoditi svoje <br/>podatke i provjeriti vašu primljenu poštu.",
  descStaff:
    "Dobrodošli u vaš osobni prostor. Ovdje možete ažurirati ili prilagoditi svoje podatke.",
  buttons: {
    showProfile: "Prikažite profil",
    userProfile: "IDITE NA OSNOVNE PODATKE",
    mailbox: "IDITE NA PRIMLJENU POŠTU",
    addNewEmail: "Dodajte novi email",
  },
  categories: {
    baseData: {
      title: "Osnovni podaci",
      desc: "Ispunite svoje osobne i podatke o tvrtki za ispravnu registraciju.",
    },
    mailbox: {
      desc: "Primajte važne obavijesti i vijesti u vašu primljenu poštu.",
    },
    bankstatement: {
      title: "Izvještaj računa",
      desc: "Ovdje možete provjeriti status vašeg osobnog Bridgestone Plus računa i pregledati vaše zarađene i iskorištene nagradne bodove.",
    },
  },
  profile: {
    general: "OSOBNI PODACI PODACI O TVRTKI",
    title: "Osnovni podaci",
    description:
      "Dobrodošli u vaš osobni prostor. Ovdje možete ažurirati ili prilagoditi svoje podatke.",
    block_description:
      "Dobrodošli u vaš osobni prostor. Ovdje možete pregledati svoje podatke",
    personalData: "OSOBNI PODACI",
    password: "Lozinka",
    password1: "Lozinka (opcionalno)*",
    password2: "Lozinka (ponovi)*",
    formOfAddress: "Titula",
    choose: "Odaberite titulu",
    mr: "Gospodin",
    mrs: "Gospođa",
    diverse: "Ostalo",
    firstname: "Ime",
    surname: "Prezime",
    position: "POZICIJA U TVRTKI",
    operatingData: "PODACI O TVRTKI",
    company: "Tvrtka",
    legalForm: "Pravna struktura",
    name: "Ime",
    streetHouseNr: "Adresa tvrtke",
    street: "Ulica",
    postcode: "Poštanski broj",
    location: "Grad",
    country: "Zemlja",
    de: "Njemačka",
    at: "Austrija",
    ch: "Švicarska",
    nl: "Nizozemska",
    it: "Italija",
    language: "Jezik",
    french: "Francuski",
    italian: "Talijanski",
    german: "Njemački",
    nederland: "Nizozemski",
    phone: "Telefon",
    website: "Web stranica",
    operatingIndicators: "Ključni operativni pokazatelji",
    tireSale: "Godišnja prodaja guma približno u jedinicama",
    tireSaleLabel: "Prodajte gume u velikim količinama",
    inches: "Od kojih ≥ 18 inča (u %)",
    inchesLabel: "Od kojih 18 inča ili više u %",
    segmentSale: "Prodaja guma po segmentima (udio Budget / Mid / Premium u %)",
    premBudget: "Premium",
    midBudget: "Srednje",
    budBudget: "Budget",
    distribution: "DISTRIBUCIJA LJETO / ZIMA / SVE SEZONE (u %)",
    summerIn: "U susret ljetu",
    winterIn: "Zima je tu",
    allSeasonIn: "Tokom cijele sezone",
    tyreSizes: "Broj sezonskih mjesta za skladištenje (kompleti guma)",
    diffDeliveryAddres: "Dodajte adresu za dostavu",
    yourEmailAddress: "Vaša email adresa.",
    clientNr: "Brojevi kupaca",
    clientNrSingular: "Broj kupca",
    clientNrContent:
      "<span class='text-danger fw-bold'>VAŽNO - MOLIMO PROČITAJTE:</span><br /><br /> Za ispravnu dodjelu vaših kupovina guma kod veletrgovca i/ili Bridgestone-a, potrebno je <b>navesti vaše odgovarajuće brojeve kupaca.</b><br/><br/>Ako imate <b>više brojeva kupaca kod veletrgovca i/ili Bridgestone-a,</b> npr. za vašu glavnu trgovinu i podružnice, molimo prvo navedite broj kupca glavne trgovine.<br/><br/><b>Prodaja s drugih brojeva kupaca će tada biti pripisana vašoj glavnoj trgovini.</b>",
    supplySource: "Izvor opskrbe",
    email: "Email adresa",
    staffEmail: "Email adresa sudionika",
    registered: "Registrirano",
    registeredAt: "Registrirano",
    lastLogIn: "Zadnja prijava",
    details: "Detalji",
    inDetail: "{name} detaljno",
    customerFile: "Kartica klijenta",
    customerHistory: "Povijest klijenta",
    currentYear: "Tekuća godina",
    bsClientNr: "Vaš Bridgestone broj kupca",
    bftClientNr: "Vaš Best4Tires broj kupca",
    acceptTerms: "Prihvatite uvjete i odredbe za sudjelovanje.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>VAŽNO - MOLIMO PROČITAJTE:</span><br />Pri prvom unosu brojeva kupaca, vaši podaci će biti provjereni za točnost i usklađenost s našim kriterijima distribucije. Odluka o aktivaciji broja(jeva) kupca i povezivanju s vašim profilom može potrajati do 5 radnih dana.",
    selectWholeSaler: "kod dobavljača (molimo odaberite)",
    cooperation: "ČLANSTVO / SURADNJA",
    error100: "Zbroj vrijednosti mora biti jednak 100%.",
    errorRange: "Vrijednost mora biti između 0 i 100",
    btw_number_label: "PDV registarski broj vaše tvrtke",
    btw_number: "PDV registarski broj",
    mobile: "Broj telefona",
    mobile_label: "Vaš mobilni broj telefona",
    iban_number: "IBAN broj vaše tvrtke",
    iban_number_label: "IBAN broj",
    yourCsNr: "Vaši brojevi kupaca",
    yourLastName: "Vaše prezime",
    positionLabel: "Odaberite poziciju",
    yourFirstName: "Vaše ime",
    companyLabel: "Tvrtka",
    numberOfSetsOfSeasonalTiresBudget: "Godišnje skladištenje",
    contactInfo: "Ako imate pitanja, molimo kontaktirajte nas: {email}",
    addAnotherCsNumber: "Dodajte još jedan Bridgestone broj kupca",
    activityAndProfile: "POSLOVNE OPERACIJE I PROFIL",
    financialEmail: "Financijski emailovi",
    indirectCustomNumberHelpMessage:
      "No pudimos detectar la configuración de tu número de cliente. Por favor, revisa tu perfil y confirma si eres un cliente directo o indirecto para continuar.",
    completeProfile: "Dovršite svoj osobni profil i dodatno",
    completeProfileBold: "osigurajte 200 bodova.",
  },
  countries: {
    al: "Albanija",
    ad: "Andora",
    at: "Austrija",
    be: "Belgija",
    by: "Bjelorusija",
    ba: "Bosna i Hercegovina",
    bg: "Bugarska",
    hr: "Hrvatska",
    cy: "Cipar",
    cz: "Češka",
    dk: "Danska",
    ee: "Estonija",
    fi: "Finska",
    fr: "Francuska",
    ge: "Gruzija",
    gr: "Grčka",
    es: "Španjolska",
    nl: "Nizozemska",
    ie: "Irska",
    is: "Island",
    kz: "Kazahstan",
    xk: "Kosovo",
    li: "Lihtenštajn",
    lt: "Litva",
    lu: "Luksemburg",
    lv: "Latvija",
    mk: "Sjeverna Makedonija",
    mt: "Malta",
    md: "Moldavija",
    mc: "Monako",
    de: "Njemačka",
    no: "Norveška",
    pl: "Poljska",
    pt: "Portugal",
    ru: "Rusija",
    ro: "Rumunjska",
    sm: "San Marino",
    rs: "Srbija",
    sk: "Slovačka",
    si: "Slovenija",
    se: "Švedska",
    ch: "Švicarska",
    tr: "Turska",
    ua: "Ukrajina",
    hu: "Mađarska",
    gb: "Ujedinjeno Kraljevstvo",
    it: "Italija",
    va: "Vatikan",
  },
  addCsNumber: {
    title: "Obavijest",
    body: "Jeste li sigurni da želite spremiti ovaj broj kupca? Akcija blokira uređivanje podataka dok administrator ne odobri.",
  },
  extraEmailSection: {
    description:
      "Dodatne email adrese se isključivo koriste za slanje BS+ marketinških informacija i/ili financijskih informacija i <b>ni pod kojim okolnostima ne smiju se koristiti za prijavu ili upravljanje</b> Bridgestone PLUS računom.",
    optionOne: "Za financijske informacije (npr. specifikacija bonusa)",
    optionTwo:
      "Za Bridgestone Plus marketinšku komunikaciju (npr. promocije/bilteni)",
    addNewEmail: "Dodajte novu email adresu",
  },
};

export default {
  messages,
};
